import React, { useEffect, useState } from "react";

import label from "../../labels/administration_en.json";

import DataCount from "../../../postExaminationProcessObjective/components/preExamReport/DataCount";
import CategoryReport from "../../../postExaminationProcessObjective/components/preExamReport/CategoryReport";

const PreExam = () => {

  const [stepName, setName] = useState("datacount");



  return (
    <div className="commonContentArea">
      <h5 className="labelMargin"> {label.PreExam} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">

          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "datacount"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="datacount"
              id="datacount-tab"
              onClick={() => setName("datacount")}
              data-toggle="tab"
              role="tab"
              aria-controls="datacount"
              aria-selected="false"
            >
              <span>Data Count</span>
            </a>
          </li>

          {/* <li className="nav-item" key="2">
            <a
              href="#"
              className={
                stepName === "categoryReport"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              onClick={() => setName("categoryReport")}
              role="tab"
            >
              <span>Category Report</span>
            </a>
          </li> */}


        </ul>



        <div className="tab-content border border-light" id="myTabContent">

          <div
            className={
              stepName === "datacount"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="datacount"
            role="tabpanel"
            aria-labelledby="datacount-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <DataCount key={stepName} />
              </div>
            </div>
          </div>

        </div>

        {/* <div
          className={
            stepName === "categoryReport"
              ? "tab-pane fade show active"
              : "tab-pane fade styled-tab"
          }
          role="tabpanel"
        >
          <div className="row dashboardCards">
            <div className="col-md-12">

              <CategoryReport />
            </div>
          </div>
        </div> */}


      </div>
    </div>
  );
}

export default PreExam;